import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { FavGotoTopButton } from "./FavGotoTopButton";

interface AudioListButtonProps {
  audios: any[];
  title: string;
  getAudios: (value: any) => void;
}

export const AudioListButton: React.FC<AudioListButtonProps> = ({
  audios,
  title,
  getAudios,
}) => {
  const { t } = useTranslation();
  const [displayCount, setDisplayCount] = useState(4);

  const showMoreAudios = () => {
    setDisplayCount(displayCount + 5); // Increase by a certain number
  };

  const showLessAudios = () => {
    setDisplayCount(4); // Reset to initial display count
  };

  return (
    <div>
      {audios?.length > 0 ? (
        <div>
          <div>
            <p
              style={{
                fontFamily: "ChanakyaUni",
                fontWeight: 700,
                fontStyle: "normal",
                color: "#b42a38",
                fontSize: "26px",
                margin: "0 0 10px",
              }}
            >
              {title}
            </p>
            <div className="row" style={{ marginBottom: "21px", padding: "0 15px" }}>
              {audios.slice(0, displayCount).map((audio: any) => (
                <div className="col-3"
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="favpagebooks"
                    key={`related-${audio.id}`}
                    onClick={() => {
                      getAudios(audio);
                    }}
                    style={{
                      backgroundColor: "#feba03",
                      backgroundImage:
                        "linear-gradient(#ffd04d,#feba03,#ffbb04)",
                      transition: "all .5s ease",
                      textAlign: "center",
                      borderRadius: "6px",
                      padding: "20px 30px",
                      boxShadow: "0 0 10px 0 #fff",
                      height: "145px",
                      margin: "0 0 22px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <img
                          className="audioicon"
                          src={
                            audio.lyricsHash != null
                              ? WithLyrics
                              : WithoutLyrics
                          }
                          onError={(e) => {
                            e.currentTarget.src = WithoutLyrics;
                          }}
                          alt={audio.name}
                          title={audio.name}
                          onClick={() => {
                            getAudios(audio);
                          }}
                        />
                        <p>
                          {audio?.name?.length > 40
                            ? audio?.name.slice(0, 40) + "..."
                            : audio?.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="fav-section-actions">
            {audios?.length > 4 &&
              (displayCount < audios?.length ? (
                <button className="favitems" onClick={showMoreAudios}>
                  {t("all_tr")} {audios?.length} {t("Audios_tr")} {t("view_tr")}
                </button>
              ) : (
                <button className="favitems" onClick={showLessAudios}>
                  {t("show_less_tr")}
                </button>
              ))}
            <FavGotoTopButton />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}; 